import { TCurrencyCode, TCurrencySymbol } from '../infra';

export const CURRENCY_CODES_BY_SYMBOL: Record<TCurrencySymbol, TCurrencyCode> = {
  '₽': 'RUB',
  '$': 'USD',
  '₴': 'UAH',
};
